import styled from '@nobia/zeus-components/lib/styled'
import rem from '@nobia/zeus-components/lib/styled/rem'

import { Heading1, Heading2, Paragraph } from '../components/typography'
import { margins } from '../styles/margins'

export const H1 = styled(Heading1)`
  margin-top: ${rem(15)};
  margin-bottom: ${rem(10)};
`

export const H2 = styled(Heading2)`
  margin-top: ${rem(16)};
`

export const NarrowWrapper = styled.div`
  overflow-x: hidden;
  width: 100%;
  padding: ${rem(10)} ${rem(margins.s)} ${rem(80)} ${rem(margins.s)};
  margin: 0 auto;
  ${(p) => p.theme.media.min.md`
    margin: 0 auto ${rem(margins.s)};
    padding: ${rem(50)} ${rem(margins.s)} ${rem(80)} ${rem(margins.l)};
  `}
  ${(p) => p.theme.media.min.lg`
    margin: 0 auto ${rem(65)} 0;
  `}
  ${(p) => p.theme.media.min.xl`
    max-width: ${rem(1270)};
  `}
`
export const WideWrapper = styled.div`
  padding: 0 0 ${rem(80)};
  width: 100%;
  ${(p) => p.theme.media.min.md`
    padding: ${rem(50)} ${rem(35)} ${rem(80)} ${rem(margins.l)};
    `}
  ${(p) => p.theme.media.min.lg`
    margin: 0 auto ${rem(65)} 0;
  `}
  ${(p) => p.theme.media.min.xl`
    max-width: ${rem(1270)};
  `}
`
export const FlexWrapper = styled.div`
  display: flex;
  text-align: left;
  flex-wrap: wrap;
  margin: 0 auto;

  ${(p) => p.theme.media.min.xl`
    flex-wrap: nowrap;
  `}
`
export const Column = styled.div`
  width: 100%;
  flex: 1 0 100%;
  padding: 0;
  margin: 0 auto;
  margin-top: ${(p) => (p.image ? rem(50) : 0)};
  max-width: ${(p) => (p.singleColumn ? '100%' : rem(500))};
  ${(p) =>
    p.theme.media.min.md`
    max-width: ${p.singleColumn ? '100%' : rem(500)};
  `}
  ${(p) => p.theme.media.min.lg`
    margin: 0;
    margin-top: ${p.image ? rem(50) : 0};
  `}
  ${(p) => p.theme.media.min.xl`
    margin: 0;
    margin-top: ${p.image ? rem(40) : 0};
    padding-right: ${rem(60)};
    max-width: ${p.image || p.singleColumn ? '100%' : rem(500)}
    min-width: ${p.image ? 'none' : '500px'}
  `};
`
export const Image = styled.div`
  background-image: ${(p) => `url(${p.img})`};
  background-size: cover;
  background-position: center;
  position: absolute;
  left: 0;
  right: 0;
  bottom: ${rem(72)};
  min-height: 40vh;
  height: ${`calc(200px + 10vw)`};
  z-index: -99;
  ${(p) => p.theme.media.min.sm`
    border-radius: 6px;
    position: static;
    width: 100%;
    min-height: auto;
  `}
`
export const Padding = styled.div`
  padding: ${rem(margins.s)};
  ${(p) => p.theme.media.min.md`
    padding: 0;
  `}
`

export const AvailableOrder = styled.div`
  width: 100%;
  min-height: 65px;
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(10)};
  padding: ${rem(16)};
  border-bottom: 1px solid #00000010;
  align-items: center;

  &:last-child {
    border-bottom: none;
  }

  ${(p) => p.theme.media.min.sm`
    grid-template-columns: repeat(3, 1fr);
    gap: ${rem(20)};

    & > *:nth-child(3) {
      text-align: right;
      justify-self: end;
  }
  `}
`

export const NoOrders = styled.div`
  padding: ${rem(40)};
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const Card = styled.div`
  background-color: ${(p) => p.theme.order.card.background};
  width: 100%;
  max-width: 685px;
  border-radius: ${(p) => p.theme.order.card.borderRadius};
  margin-top: ${rem(22)};
  margin-bottom: ${rem(40)};
`

export const OrderNumber = styled(Paragraph)`
  text-decoration: underline;
  font-weight: 500;
  cursor: pointer;
`

export const Border = styled.div`
  margin-top: ${rem(20)};
  margin-bottom: ${rem(20)};
  border-bottom: 1px solid ${(p) => p.theme.colors.gold};
`
